import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AppShell from '../components/AppShell';
import Button from '../components/Button';
import Callout from '../components/Callout';
import { api } from '../lib/api';
import { useAuth } from '../lib/useAuth';

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);

  useEffect(() => {
    // Links are single use, so this must not fire twice under StrictMode.
    if (ran.current) return;
    ran.current = true;

    const token = params.get('token');
    if (!token) {
      setError('That link is missing its code. Ask for a fresh one.');
      return;
    }

    api
      .verifyMagicLink(token)
      .then(async () => {
        await refresh();
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        setError(
          'This link is no longer valid. The usual reason is an older email: asking ' +
            'for a new link switches off every earlier one, so check for the most ' +
            'recent message before requesting another.',
        );
      });
  }, [params, navigate, refresh]);

  if (!error) {
    return (
      <AppShell>
        <p className="t-body text-grey-600">Signing you in…</p>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <h1 className="t-h1 text-ink">That link did not work</h1>
      <div className="mt-6 max-w-xl">
        <Callout tone="caution" title="Check for a newer email first">{error}</Callout>
      </div>
      <div className="mt-8">
        <Link to="/login">
          <Button>Email me a new link</Button>
        </Link>
      </div>
    </AppShell>
  );
}
